<clare-main-content-container [isNavNeeded]="true">
    <ng-container secondaryNav>
        <div id="account-list-menu">
            <div id="meta-section">
                <div class="user">
                    <div>Welcome</div>
                    <div>{{ userDisplayName }}</div>
                </div>
                <div class="company">
                    <div>Company:</div>
                    <div>
                        {{ userCompanyName }}
                    </div>
                </div>
            </div>
            <div id="filter-section">
                <div class="status-filter">
                    <div class="filter-title">Status</div>
                    <div>
                        <clare-list-filter-checkbox-group
                            filterColumn="onlineStatus"
                            [statusCounts]="onlineStatuses"
                            (changeFilterHandler)="onFilterChange($event)"
                            [initialActiveFilters]="projectFilter?.selectedFilters?.['onlineStatus']"
                        >
                        </clare-list-filter-checkbox-group>
                        <clare-list-filter-checkbox-group
                            *ngIf="isAbleToSuspendAccount"
                            filterColumn="inactive"
                            [statusCounts]="activeCounts"
                            [initialActiveFilters]="projectFilter?.selectedFilters?.['inactive']"
                            (changeFilterHandler)="onFilterChange($event)"
                        >
                        </clare-list-filter-checkbox-group>
                    </div>
                </div>
                <div class="status-filter">
                    <div class="filter-title">Service Plans</div>
                    <div>
                        <clare-list-filter-checkbox-group
                            filterColumn="monitoredStatus"
                            [statusCounts]="servicePlanCounts"
                            (changeFilterHandler)="onFilterChange($event)"
                            [initialActiveFilters]="projectFilter?.selectedFilters?.['monitoredStatus']"
                        >
                        </clare-list-filter-checkbox-group>
                    </div>
                </div>
                <div class="status-filter">
                    <div class="filter-title">Occupancy</div>
                    <div>
                        <clare-list-filter-checkbox-group
                            filterColumn="isOccupied"
                            [statusCounts]="occupancyCounts"
                            (changeFilterHandler)="onFilterChange($event)"
                            [initialActiveFilters]="projectFilter?.selectedFilters?.['isOccupied']"
                        >
                        </clare-list-filter-checkbox-group>
                    </div>
                </div>
                <div class="status-filter">
                    <div class="filter-title">Lockout Screen</div>
                    <div>
                        <clare-list-filter-checkbox-group
                            filterColumn="lockoutTime"
                            [statusCounts]="[lockoutTimeCount]"
                            (changeFilterHandler)="onFilterChange($event)"
                            [initialActiveFilters]="projectFilter?.selectedFilters?.['lockoutTime']"
                        >
                        </clare-list-filter-checkbox-group>
                    </div>
                </div>
                <div id="filter-bottom" (click)="resetFilters()">
                    <p>Reset and Clear Filters</p>
                </div>
            </div>
            <div id="bottom-action">
                <ng-container *ngIf="exportCSVFactoryConfig$ | async as csvConfig">
                    <app-account-export
                        *ngIf="exportCSVFactoryConfig$.value.config"
                        [isLink]="true"
                        [config]="exportCSVFactoryConfig$.value.config"
                    ></app-account-export>
                </ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container mainContent>
        <div class="redesign-content-container" *letVar="dataSource$ | async as dataSource">
            <div class="header-container">
                <div class="content-container">
                    <div id="account-list-action">
                        <div class="dealer-selection" fxLayout="row" fxLayout.lt-sm="column">
                            <span fxLayout="row" fxLayout.lt-sm="column"
                                ><span class="accounts-label">Accounts&nbsp;</span> ({{ dataSource?.length || 0 }} of {{ totalAccount }})
                                /&nbsp;</span
                            >
                            <div class="dealer-selection-dropdown">
                                <subdealer-selector
                                    selectListFilter
                                    [subdealers]="entities$ | async"
                                    [selectedEntityId]="selectedEntityId$ | async"
                                    (selectionMade)="onSelectSubdealer($event)"
                                ></subdealer-selector>
                            </div>
                        </div>
                        <div id="actions">
                            <button mat-raised-button id="btnAdd" class="new-primary-button" (click)="addProject($event)">
                                + <ng-container i18n="@@SHARED.BTN.ADD">Create Account</ng-container>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="selectedEntity$ | async as entity" class="subdealer-banner" banner>
                        Viewing
                        <b class="entity-name">{{ entity.name }}</b>
                        accounts below
                    </div>
                </div>
            </div>
            <div class="scrollable-content">
                <div class="content-container">
                    <clare-list-view
                        placeholder="Search Accounts by Name, Address, UUID, etc."
                        title="Accounts"
                        sortActive="name"
                        [isMobileView]="isMobileView$ | async"
                        [tableActionOptions]="tableActionOptions"
                        [callState]="callState$ | async"
                        [columns]="columns$ | async"
                        [factoryConfig]="projectViewConfig$ | async"
                        [source]="dataSource"
                        [statusCounts]="onlineStatuses"
                        [activeCounts]="activeCounts"
                        [initialQueryString]="projectFilter.searchTerm"
                        [initialStatusFilters]="projectFilter.selectedFilters"
                        [isSearchSuffixIconShown]="true"
                        (onAdd)="addProject($event)"
                        (onRefresh)="refresh()"
                        (onEdit)="editProject($event)"
                        (onFilter)="updateTableProperties($event)"
                        [pageSize]="pageSize"
                        [isAccountListView]="true"
                        [hidePageSize]="true"
                        [hideHeader]="true"
                        [hideRefresh]="true"
                    >
                    </clare-list-view>
                </div>
            </div>
        </div>
    </ng-container>
</clare-main-content-container>
